import React from "react";

function QABundle() {
  return <div>QABundle</div>;
}

export default QABundle;
